<template>
  <div>
    <b-row class="mt-5 justify-content-center">
      <b-col md="5">
        <b-form class="login" @submit="onSubmit">
          <b-form-row>
            <b-col>
              <b-form-group description="Enter unique username.">
                <b-input
                  size="md"
                  required
                  v-model="form.username"
                  type="text"
                  placeholder="Username"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group description="Enter users email.">
                <b-input
                  size="md"
                  required
                  v-model="form.email"
                  type="email"
                  placeholder="Email"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group description="Enter unique password.">
                <b-input
                  size="md"
                  required
                  v-model="form.password"
                  type="password"
                  placeholder="Password"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-button
                type="submit"
                class="btn btn-dark btn-md"
                :disabled="isSending"
              >
                Create new user
              </b-button>
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      isSending: false,
      form: {
        username: null,
        email: null,
        password: null,
      },
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.isSending = true;
      return new Promise((resolve, reject) => {
        axios({
          url: this.$store.state.login.url + "/api/dashboard/users/new",
          headers: {
            Authorization: `Bearer ${this.$store.state.login.token}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify(this.form),
          method: "POST",
        })
          .then((response) => {
            // cleanup form
            for (var member in this.form) delete this.form[member];
            this.isSending = false;
            this.$router.push("/").then(() => {
              this.$bvToast.toast(response.data.message, {
                title: "Success",
                autoHideDelay: 5000,
              });
            });
            resolve(response);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
  },
};
</script>
